export default "<app-t-topics></app-t-topics>\r\n"